import React from 'react';
import ReactTooltip from 'react-tooltip';
import './style.scss';
const ToolTipWrapper = ({
  children,
  dataFor,
  type,
  effect,
  clickable,
  delayHide,
  hoverText
}) => {
  return (
    <React.Fragment>
      {children}
      <ReactTooltip
        className="tool-tip-window"
        type={type}
        effect={effect}
        data-for={dataFor}
        clickable={clickable}
        delayHide={delayHide}
      >
        <p>{hoverText}</p>
      </ReactTooltip>
    </React.Fragment>
  );
};

export default ToolTipWrapper;
